import { setDoc, doc } from "firebase/firestore";
import { firestoreDb } from "../firebase";
import { DbInstance, LICENSE } from "../utils/constants";
import resolveDb from "../db";
import { FORM_LOCALES, HINT_IMAGES } from "../static-config";

const db = resolveDb(DbInstance.JSON_DB);

function buildLocales() {
	const result: Record<string, Record<string, string>> = {};
	for (const lang of Object.keys(FORM_LOCALES)) {
		const images = HINT_IMAGES[lang] || {};
		const wrappedImages: Record<string, string> = {};
		for (const [key, url] of Object.entries(images)) {
			wrappedImages[key] = `<img src="${url}" style="max-width:100%" />`;
		}
		result[lang] = { ...FORM_LOCALES[lang], ...wrappedImages };
	}
	return result;
}

export async function loadConfig(_unused?: unknown) {
	return buildLocales();
}

export async function loadLocals() {
	return buildLocales();
}

export async function checkUpdates() {
	// Forms / locales / images are now bundled statically; no remote check needed.
	return null;
}

export async function markLicenseAsUsed() {
	const license = await db.get(LICENSE);

	await setDoc(
		doc(firestoreDb, "code_requests", license as string),
		{ used: true },
		{ merge: true }
	).catch(console.log);
}
